import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "bootstrap/scss/bootstrap.scss";
import "simplebar/dist/simplebar.min.css";
import "./index.css";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { BrowserRouter, createBrowserRouter, RouterProvider, createRoutesFromElements, Route, Routes } from "react-router-dom";
import CustomRouter from "./Router/BrowserRouter";
import { history } from "./Router/History";
import ShareholdersRevamp from './pages/Underwriting/CompanyDetails/ShareholdersRevamp';
import { initSentry } from "./config/sentry";
import { initAnalytics } from "./config/amplitude";

// Initialize Sentry for production
initSentry();

// Initialize Amplitude analytics — must run before RouterProvider mounts.
// All event tracking goes through src/config/amplitude.ts (see that file for config).
initAnalytics();


const router = createBrowserRouter(
  createRoutesFromElements(
    // <App />
    <Route path='/*' element={<App />} />
  )
)


createRoot(document.getElementById('root')!).render(
  // <StrictMode>
  <Provider store={store}>
    <RouterProvider router={router as any} />
  </Provider>
  // </StrictMode>
)

// ReactDOM.render(
//   <React.StrictMode>
//     <CustomRouter history={history}>
//       <Provider store={store}>
//         <App />
//       </Provider>
//     </CustomRouter>
//   </React.StrictMode>,
//   document.getElementById("root"),
// );

reportWebVitals();
